/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DealerManagementApiService {
  private history = [];
  public img = '';
  previousUrl;
  private APIService = environment.serviceUrl;

  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar,
    private router: Router
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  createDealer(Payload): Observable<any> {
    return this.http.post(this.APIService + 'dealers/createDealer', Payload);
  }

  //Fetch user single data  /user/userdetails?id=
  getSingleDealer(id): Observable<any> {
    return this.http.get(this.APIService + 'dealers/getDealerDetail?id=' + id);
  }

  //Update user  user/customerDetailsUpdate user/userdetailsupdate
  updateUser(Payload): Observable<any> {
    return this.http.put(
      this.APIService + 'dealers/updateDealerdetails',
      Payload
    );
  }

  getAllDealer(currentPage, pageSize, search, userRefId): Observable<any> {
    return this.http.get(
      this.APIService +
        'dealers/getDealerList?page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&search=' +
        search +
        '&userRefId=' +
        userRefId
    );
  }

  deleteDealer(Sid): Observable<any> {
    return this.http.delete(`${this.APIService}dealers/delete/${Sid}`);
  }

  getAllDealersOtaList(currentPage, pageSize, search): Observable<any> {
    return this.http.get(
      this.APIService +
        'dealersOta/getAllDealersOtaList?page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&search=' +
        search
    );
  }
}
